import React from 'react';
import styles from './Notifications.module.scss';
import { useAutoAnimate } from '../../hooks/useAutoAnimate.tsx';

interface NotificationsContainerProps {
    children: React.ReactNode;
}

export const NotificationsContainer: React.FC<NotificationsContainerProps> = ({ children }) => {
    const containerRef = useAutoAnimate<HTMLDivElement>();

    return (
        <div
            ref={containerRef}
            className={styles.notificationsContainer}
        >
            {children}
        </div>
    );
};